const global = window

inputs.types.password = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.type == 'newPassword') {
	    setTimeout(function () {
	        if (!input.is(':focus')) {
	            input.val('')
	        }
	    }, 3000)
	    const progress = $(
	        '<div class="progress__thin"><div class="progress" data-max="100" data-target="high"></div></div>'
	    )
	    input.after(progress)
	    input.change(function () {
			/*
	        scorePassword($(this).val())
	        progress
	            .find('.progress')
	            .data('progress', scorePassword($(this).val()))
            progressWidget(progress)
			*/
	    })
	    input.keyup(function () {
	        $(this).change()
	    })
    }
    return data
}
